<template>
  <div class="fireflies-container">
    <vue-particles
      id="particles"
      @particles-loaded="particlesLoaded"
      :options="firefliesOptions"
    ></vue-particles>
    <div id="fireflies-wrapper">
      <firefly 
        v-for="(ff, index) in particleList" :key="`${ff.position.x}${ff.position.y}`"
        :firefly="ff" :position="positionList[index]" :ref="`ff${ff.id}`"
        @mouseenter="hoveredFirefly = ff"
        @mouseleave="hoveredFirefly = null"
      ></firefly>
      <firefly-tag v-if="hoveredFirefly" :x="hoveredFirefly.position.x" :y="hoveredFirefly.position.y">
        {{ hoveredFirefly.position.x }}, {{ hoveredFirefly.position.y }}
      </firefly-tag>
    </div>
  </div>
</template>

<script>
import firefliesOptions from '@/assets/FirefliesOptions.json';
import firefly from '@/components/Firefly.vue';
import fireflyTag from '@/components/FireflyTag.vue'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Fireflies',
  // width: the width of the component
  // height: the height of the component
  props: ['width', 'height'],
  components: { firefly, fireflyTag },
  data () {
    return {
      firefliesOptions: firefliesOptions,
      particleContainer: null,
      hoveredFirefly: null,
      keyRefresh: 0,
      positionList: [],
      canvas: null
    }
  },
  computed: {
    particleList () {
      return this.particleContainer ? this.particleContainer.particles._array : this.particleContainer;
    },
    // width for wrapper to match particle canvas virtual width
    wrapperWidth () {
      const width = this.canvas ? `${this.canvas.getAttribute('width')}px` : this.width;
      return width;
    },
    // height for wrapper to match particle canvas virtual height
    wrapperHeight () {
      const height = this.canvas ? `${this.canvas.getAttribute('height')}px` : this.height;
      return height;
    },
    wrapperScale () {
      return document.querySelector('.fireflies-container').offsetHeight / parseInt(this.wrapperHeight);
    }
  },
  methods: {
    particlesLoaded (container) {
      console.log('particles loaded !!');
      
      this.particleContainer = container;
      this.canvas = document.querySelector('#particles > canvas');

      this.handleParticles();
      setInterval(() => {
        this.handleParticles();
      }, 50);
    },
    handleParticles () {
      const positionList = [];
      this.particleList.forEach(ff => {
        positionList.push(ff.position);
      });
      this.positionList = positionList;
    }
  }
}
</script>

<style scoped>
.fireflies-container {
  background: radial-gradient(midnightblue, black);

  min-width: v-bind(width);
  min-height: v-bind(height);

  position: relative; 
  overflow: hidden;
}

#fireflies-wrapper {
  width: v-bind(wrapperWidth);
  height: v-bind(wrapperHeight);
  transform-origin: 0 0;
  transform: scale(v-bind(wrapperScale));

  position: absolute;

  top: 0px;
  left: 0px;
}
</style>